
import AuthorizationsService from "../../services/authorizations/AuthorizationsService";
import ProviderService from "../../services/masters/ProviderService";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  
  data() {

    const data = [

  ]
    return {
      b:0,
      data,
        checkboxPosition: 'left',
        checkboxType: 'is-primary',
        checkedRows: [data[1], data[3]],
      perPage: 4,
      currentPage: 1,
      medicinesData: [],
      checkedRows: [],
      checkAll: false,
      orderDetails: null,
      seleccionado: [],
      checkedAll: true,
      slidingScaleFee: 0,
      shippingFee: 0,
      providers: [],
      patient: null,
      name: "",
      importations: [],
      loading: false,
      solicitardomicilio: 0,
      solicitarreclamacion: 0,
      seleccionCheck: 0,
      
    };
  },

  created() {
   
    this.checkedRows = [];
    // this.getImportations()
    this.loading = true;
    this.getAuthorizations();
    this.loading = false;
    this.getProviders();
    this.solicitardomicilio = this.checkedRows.length;
    this.seleccionado = this.$refs.myTable;
  },

  computed: {
    
    rows() {
      return this.medicinesData.length;
    },


    ...mapState("auth", {
      user: "user",
    }),

    ...mapState("delivery", {
      selectedMedicines: "selectedMedicines",
    }),

    ...mapGetters("auth", {
      isAuthenticated: "isAuthenticated",
    }),

    isRequestDeliveryEnable() {
      return this.isMedicines && this.isCheckedRows;
    },

    isMedicines() {
      return this.medicinesData && this.medicinesData.length > 0;
    },

    isCheckedRows() {
      return this.checkedRows && this.checkedRows.length > 0;
    },

    isAnySpecialMedicine() {
      return this.medicinesData.some(
        (medicine) =>
          medicine.isWatched == true ||
          medicine.isApplicable == true ||
          medicine.isImported == true
      );
    },
  },

  methods: {
    seleccionarTodos() {
      this.checkAll = !this.checkAll;
      const table = this.$refs.myTable;
       table.checkedRows.push(...table.newData);
       this.checkedRows.push(...table.newData);

       this.checkedRows = [...new Set(this.checkedRows.filter(x => typeof x.isApplicable == "undefined" || x.isApplicable == false))];
       console.log("tablenewData",this.checkedRows);
      this.seleccionCheck = 1;

    },
    handleDeselect() {
      // if (!this.checkAll) {
        const table = this.$refs.myTable;
        while (table.checkedRows.length > 0) {
          table.checkedRows.pop();
          this.checkedRows.pop();
        }
        this.checkAll = !this.checkAll;
      // }
    },
    async getImportations() {
      try {
        const response = await AuthorizationsService.getImportations();
        if (response && response.data) {
          this.importations = response.data;
        }
      } catch (error) {
        if (!this.isAuthenticated) return;

        this.$buefy.toast.open({
          message: this.$t("app.components.home.error-getting-authorizations"),
          type: "is-danger",
        });
      }
    },
    async getAuthorizations() {
      try {
        this.checkedRows = [];
        const response = await AuthorizationsService.getAuthorizations(
          this.user.identification
        );

        if (response && response.data) {
          if (!Object.keys(response.data).length) {
            this.$buefy.toast.open({
              message: "En este momento no tienes autorizaciones pendientes",
              type: "is-danger",
              duration: 20000,
            });
          } else if (
            response.data.message &&
            response.data.message === "NO_AUTHORIZATIONS_FOUND"
          ) {
            this.$buefy.toast.open({
              message: "En este momento no tienes autorizaciones pendientes",
              type: "is-danger",
              duration: 20000,
            });
          } else {
            this.orderDetails = response.data.orderDetails;
            this.patient = response.data.patient;
            this.name = this.patient.name.toLowerCase();
            let auxMedicines = [];

            if (this.orderDetails) {
              auxMedicines = this.orderDetails
                .flatMap((orderDetail) => orderDetail.medicines)
                .map((medicine, i) => {
                  medicine.id = i;
                  if (
                    this.importations.find(
                      (importation) => importation.plu === medicine.plu
                    )
                  ) {
                    medicine.isImported = true;
                  } else {
                    medicine.isImported = false;
                  }
                  return medicine;
                });
            }

            for (let i = 0; i < auxMedicines.length; i++) {
              const medicine = auxMedicines[i];
              if (medicine.isApplicable || medicine.isWatched || medicine.isImported) {
                for (let j = 0; j < auxMedicines.length; j++) {
                  if (medicine.orderDetailCode === auxMedicines[j].orderDetailCode) {
                    auxMedicines[j].isApplicable = true;
                  }
                }
              }
            }

            this.medicinesData = auxMedicines;

            // if (this.selectedMedicines)
            //     this.$nextTick(() => {

            //         this.checkedRows = this.medicinesData.filter(
            //             medicine => this.selectedMedicines
            //                 .some(selectedMedicine => selectedMedicine.id == medicine.id)
            //         )
            //     })
          }
        }
      } catch (error) {
        console.log(error);
        if (!this.isAuthenticated) return;
        // console.log(error)
        this.$buefy.toast.open({
          message: this.$t("app.components.home.error-getting-authorizations"),
          type: "is-danger",
        });
      }
    },

    getProviders() {
      ProviderService.getProviders()
        .then((response) => {
          if (response && response.data) this.providers = response.data;
        })
        .catch((error) => console.log("error :", error));
    },

    ...mapActions("delivery", [
      "setMedicines",
      "setOrderDetails",
      "setProvider",
      "setPatient",
    ]),
    requestAppointment() {
      // this.$router.push('/request-appointment');
      if (this.checkedRows && this.checkedRows.length > 0) {
        const selectedOrderDetails = this.orderDetails.filter((orderDetail) =>
          this.checkedRows.some((row) => row.orderDetailCode == orderDetail.code)
        );

        const selectedMedicines = this.medicinesData.filter((medicine) =>
          this.checkedRows.some((row) => row.orderDetailCode == medicine.orderDetailCode)
        );

        const providerNits = selectedOrderDetails.map((od) => od.providerFiscalNumber);

        const uniqueProviders = [...new Set(providerNits)];

        let providerId = 1; // Farmadomicilios id

        // if (uniqueProviders.length == 1)
        //     providerId = this.providers
        //         .find(provider => provider.fiscalNumber == uniqueProviders[0]).id

        this.setProvider(providerId);
        this.setMedicines(selectedMedicines);

        const orderDetails = selectedOrderDetails.map((od) => {
          od.orderCode = od.code;
          // od.medicines = this.checkedRows.filter(row => row.orderDetailCode == od.code)
          od.scaleFee = od.slidingScaleFee;
          od.deliveryNumber = od.number;
          // od.providerId = this.providers
          //     .find(provider => provider.fiscalNumber == od.providerFiscalNumber).id

          return od;
        });

        this.setOrderDetails(orderDetails);
        this.setPatient(this.patient);

        this.$router.push("/request-appointment");
      } else {
        const message = this.$t(
          "app.components.home.at-least-one-medicine-must-be-selected"
        );
        this.$buefy.toast.open({ message, type: "is-danger" });
      }
    },
    requestDelivery() {
      if (this.checkedRows && this.checkedRows.length > 0) {
        const selectedOrderDetails = this.orderDetails.filter((orderDetail) =>
          this.checkedRows.some((row) => row.orderDetailCode == orderDetail.code)
        );

        const selectedMedicines = this.medicinesData.filter((medicine) =>
          this.checkedRows.some((row) => row.orderDetailCode == medicine.orderDetailCode)
        );

        const providerNits = selectedOrderDetails.map((od) => od.providerFiscalNumber);

        const uniqueProviders = [...new Set(providerNits)];

        let providerId = 1; // Farmadomicilios id

        if (uniqueProviders.length == 1)
          providerId = this.providers.find(
            (provider) => provider.fiscalNumber == uniqueProviders[0]
          ).id;

        this.setProvider(providerId);
        this.setMedicines(selectedMedicines);

        const orderDetails = selectedOrderDetails.map((od) => {
          od.orderCode = od.code;
          // od.medicines = this.checkedRows.filter(row => row.orderDetailCode == od.code)
          od.scaleFee = od.slidingScaleFee;
          od.deliveryNumber = od.number;
          od.providerId = this.providers.find(
            (provider) => provider.fiscalNumber == od.providerFiscalNumber
          ).id;

          return od;
        });

        this.setOrderDetails(orderDetails);
        this.setPatient(this.patient);

        this.$router.push("/request-delivery");
      } else {
        const message = this.$t(
          "app.components.home.at-least-one-medicine-must-be-selected"
        );
        this.$buefy.toast.open({ message, type: "is-danger" });
      }
    },
  },
};
